import React from "react";
import irfana from "../../images/Female/irfana.jpg";
import tarannum from "../../images/Female/tarannum.jpg";
import zeba from "../../images/Female/zeba.jpg";
import sameena from "../../images/Female/samena.jpg";
import nidha from "../../images/Female/nidha.jpg";
import arshiya from "../../images/Female/arshiya.jpg";
import soujanya from "../../images/Female/soujanya.jpg";
import mohibunnisa from "../../images/Female/mohibunnisa.jpg";
import taskeen from "../../images/Female/taskeen.jpg";
import mahek from "../../images/Female/mahek.jpg";
import shahnaz from "../../images/Female/shahnaz.jpg";
import amathullah from "../../images/Female/amantullah.jpg";
import rayed from "../../images/Female/rayeesa.jpg";
import faheemunnisa from "../../images/Female/faheemunnisa.jpg";
import zebafatima from "../../images/Female/zebafatima.jpg";
import tasmiya from "../../images/Female/tasmiya.jpg";
import rumaisa from "../../images/Female/rumaisa.jpg";

import anwar from "../../images/Male/anwar.jpg";
import mujeeb from "../../images/Male/mujeeb.jpg";
import rafi from "../../images/Male/rafi.jpg";
import abdullah from "../../images/Male/abdullah.jpg";
import suleman from "../../images/Male/suleman.jpg";
import hakeem from "../../images/Male/hakeem.jpg";
import rahmani from "../../images/Male/rahmani.jpg";

import "./Staff.css";

const femaleStaffData = [
  {
    name: "Irfana Tanveer",
    qualification: "M.A., B.Ed.",
    designation: "Vice Principal",
    experience: "12 Years",
    image: irfana,
  },
  {
    name: "Tarannum Sultana",
    qualification: "M.A., B.Ed.",
    designation: "Incharge",
    experience: "8 Years",
    image: tarannum,
  },
  {
    name: "Zeba Zareen",
    qualification: "M.A., B.Ed.",
    designation: "Co-Ordinator",
    experience: "6 Years",
    image: zeba,
  },
  {
    name: "Sameena Afroze",
    qualification: "Hindi Vidwan",
    designation: "L.K.G Mother Teacher",
    experience: "17 Years",
    image: sameena,
  },
  {
    name: "Nidha Mehvish",
    qualification: "M.A., B.Ed.",
    designation: "L.K.G Mother Teacher",
    experience: "9 Years",
    image: nidha,
  },
  {
    name: "Arshiya Begum",
    qualification: "B.A., B.Ed.",
    designation: "Sci, Soc (Primary)",
    experience: "6 Years",
    image: arshiya,
  },
  {
    name: "Ramancha Soujanya",
    qualification: "M.B.A., B.Ed.",
    designation: "Telugu (Primary)",
    experience: "10 Years",
    image: soujanya,
  },
  {
    name: "Mohibbunnisa",
    qualification: "M.A., B.Ed.",
    designation: "Mother Teacher",
    experience: "4 Years",
    image: mohibunnisa,
  },
  {
    name: "Taskeen Firdouse",
    qualification: "B.Tech",
    designation: "U.K.G Mother Teacher",
    experience: "3 Years",
    image: taskeen,
  },
  {
    name: "Firdouse Mahek",
    qualification: "B.Sc., MPCS.",
    designation: "Mother Teacher",
    experience: "2 Years",
    image: mahek,
  },
  {
    name: "Shahnaz Tabassum",
    qualification: "M.C.A., B.Ed.",
    designation: "Mother Teacher",
    experience: "6 Years",
    image: shahnaz,
  },
  {
    name: "Amathullah Afreen",
    qualification: "B.A.(Alima, Mufthiath)",
    designation: "Urdu/Deeniyath",
    experience: "3 Years",
    image: amathullah,
  },
  {
    name: "Rayees Fatima",
    qualification: "M.A., B.Ed.",
    designation: "Mother Teacher",
    experience: "17 Years",
    image: rayed,
  },
  {
    name: "Faheemunnisa",
    qualification: "Hindi Pandit.",
    designation: "Hindi (Higher)",
    experience: "10 Years",
    image: faheemunnisa,
  },
  {
    name: "Zeba Fathima",
    qualification: "M.A., B.Ed.",
    designation: "Art & Craft",
    experience: "5 Years",
    image: zebafatima,
  },
  {
    name: "Tasmiya Kouser",
    qualification: "B.Sc",
    designation: "Computer/GK",
    experience: "1 Years",
    image: tasmiya,
  },
  {
    name: "Rumaisa Aieman",
    qualification: "B.Sc",
    designation: "Olympiad",
    experience: "1 Years",
    image: rumaisa,
  },
];

const maleStaffData = [
  {
    name: "Syed Anwarullah",
    qualification: "M.A., B.Ed.",
    designation: "Principal",
    experience: "19 Years",
    image: anwar,
  },
  {
    name: "Mohammed Mujibuddin",
    qualification: "M.Sc., B.Ed.",
    designation: "Mathematics Higher",
    experience: "13 Years",
    image: mujeeb,
  },
  {
    name: "Mohammed Rafi",
    qualification: "BA Telugu",
    designation: "Telugu Higher",
    experience: "28 Years",
    image: rafi,
  },
  {
    name: "MD. Abdullah",
    qualification: "B.Sc., B.Ed.",
    designation: "P.E.T (P. Ed.)",
    experience: "15 Years",
    image: abdullah,
  },
  {
    name: "Mohammed Suleman",
    qualification: "M.Sc.",
    designation: "Biology (Higher)",
    experience: "5 Years",
    image: suleman,
  },
  {
    name: "Mohammed Abdul Hakeem",
    qualification: "M.Sc., B.Ed., M.Ed.",
    designation: "Physics (Higher)",
    experience: "9 Years",
    image: hakeem,
  },
  {
    name: "Rahmani Zubeb",
    qualification: "B.A. (Finance)",
    designation: "Accountant",
    experience: "3 Years",
    image: rahmani,
  },
];

const StaffGrid = ({ data }) => {
  return (
    <div className="staff-grid">
      {data.map((staff, index) => (
        <div className="staff-card" key={index}>
          <img src={staff.image} alt={staff.name} />
          <div className="staff-info">
            <h3>{staff.name}</h3>
            <p>{staff.qualification}</p>
            <p>{staff.designation}</p>
            <p>{staff.experience}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

const Staff = () => {
  return (
    <div className="abc">
       <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        {/* <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}> */}
          Staff & Management
        {/* </span> */}
      </h1>
      <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Male Staff
        </span>
      </h1>
      <StaffGrid data={maleStaffData} />
      <br />
      <h1 style={{ textAlign: "center", marginBottom: "20px", position: "relative" }}>
        <span style={{ borderBottom: "5px solid gold", padding: "3px", display: "inline-block" }}>
          Female Staff
        </span>
      </h1>      <StaffGrid data={femaleStaffData} />
    </div>
  );
};

export default Staff;
